<template>
  <article
    class="solic-card"
    :style="{ borderColor: getBorderColor(solicType) }"
  >
    <section
      class="d-flex justify-space-between items-center header-section"
      style="width: 100%;"
    >
      <div
        class="d-flex align-center"
        style="gap: 15px;"
      >
        <span style="font-weight: 600; font-size: 15px; color: #E7E3FC;">N° SLT: <strong style="color: #FF821A; font-weight: 500;">{{ solicitation.code || '-' }}</strong> </span>
        <div
          v-if="solicitation.is_parent"
          class="badge-container"
        >
          <div
            class="badge"
            style="background-color: #9A62FD1A; color: #9A62FD;"
          >
            <v-icon
              color="#9A62FD"
              size="16"
              style="margin-right: 4px;"
            >
              {{ icons.mdiLinkVariant }}
            </v-icon>
            <span>Pai</span>
          </div>
        </div>
        <div
          v-if="solicitation.checklist_type"
          class="badge-container"
        >
          <div
            class="badge"
            :style="solicitation.checklist_type === 'start' ? 'background-color: #56CA001A; color: #56CA00;' : 'background-color: #0085FF1A; color: #0085FF;'"
          >
            <v-icon
              :color="solicitation.checklist_type === 'start' ? '#56CA00' : '#0085FF'"
              size="16"
              style="margin-right: 4px;"
            >
              {{ icons.mdiLocationExit }}
            </v-icon>
            <span>{{ solicitation.checklist_type === 'start' ? 'Checklist de saída' : 'Checklist de retorno' }}</span>
          </div>
        </div>

        <div
          v-if="solicitation.is_child"
          class="badge-container"
        >
          <div
            class="badge"
            style="background-color: #EF70FF1A; color: #EF70FF;"
          >
            <span>Filha</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-center gap-2">
        <v-icon
          color="#E7E3FC"
          size="20"
        >
          {{ icons.mdiAccountOutline }}
        </v-icon>
        <span style="font-weight: 500; font-size: 14px;">Solicitado por <strong>{{ (solicitation.created_by && solicitation.created_by.name) || '-' }}</strong> no dia {{ formatDate(solicitation.created_at) || '-' }} - {{ formatTime(solicitation.created_at) || '-' }}</span>
      </div>
    </section>
    <div class="separator"></div>
    <section class="card-content">
      <div class="route-section">
        <span class="content-label">Rota</span>
        <div>
          <v-timeline
            dense
            align-top
            outlined
            class="timeline-custom-dense timeline-custom-dots"
          >
            <v-timeline-item
              color="success"
              outlined
              small
            >
              <span style="font-size: 14px; font-weight: 600; color: #E7E3FC;">{{ (solicitation.departure_point && solicitation.departure_point.fantasy_name) || '-' }}</span>
            </v-timeline-item>
            <v-timeline-item
              color="info"
              outlined
              small
            >
              <div
                class="d-flex flex-column"
                style="gap: 5px; color: #E7E3FC; font-size: 14px; font-weight: 600;"
              >
                <span>{{ (solicitation.address && solicitation.address.local_name) || '-' }}</span>
                <span style="font-weight: 500; font-size: 12px;">{{ formatAddress(solicitation.address) }}</span>
              </div>
            </v-timeline-item>
          </v-timeline>
        </div>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <span class="content-label">Categoria</span>
          <div class="info-content">
            <v-icon
              color="#E7E3FC"
              size="20"
            >
              {{ icons.mdiSignDirection }}
            </v-icon>
            <span>{{ solicitation.category || '-' }}</span>
          </div>
        </div>
        <div class="info-item">
          <span class="content-label">Data saída</span>
          <div class="info-content">
            <v-icon
              color="#E7E3FC"
              size="20"
            >
              {{ icons.mdiCalendar }}
            </v-icon>
            <span>{{ formatDate(solicitation.departure_date_time) || '-' }}</span>
          </div>
        </div>
        <div class="info-item">
          <span class="content-label">Motorista</span>
          <div v-if="solicitation.driver && solicitation.driver.name">
            <v-tooltip
              bottom
              color="#000000a1"
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  style="gap: 10px;"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-avatar
                    :size="40"
                    class="v-avatar-light-bg success--text"
                  >
                    <v-img
                      v-if="solicitation.driver && solicitation.driver.url_photo"
                      :src="solicitation.driver.url_photo"
                    />
                    <span
                      v-else
                      style="font-weight: 600;"
                    >
                      {{ getInitials(solicitation.driver) }}
                    </span>
                  </v-avatar>
                  <!-- <div class="badge-container">
                    <div
                      class="badge"
                      :style="returnStyleBasedOnStatus(solicitation.driver.situation)"
                    >
                      <span>{{ solicitation.driver && solicitation.driver.situation || 'Disponível' }}</span>
                    </div>
                  </div> -->
                </div>
              </template>
              <span>{{ (solicitation.driver && solicitation.driver.name) || '-' }} - {{ (solicitation.driver && solicitation.driver.occupation_sector && solicitation.driver.occupation_sector.occupation && solicitation.driver.occupation_sector.occupation.name) || 'Motorista' }}</span>
            </v-tooltip>
          </div>
          <div
            v-else
            class="info-content"
          >
            <span>-</span>
          </div>
        </div>
        <div class="info-item">
          <span class="content-label">Horário saída</span>
          <div class="info-content">
            <v-icon
              color="#E7E3FC"
              size="20"
            >
              {{ icons.mdiClockTimeEightOutline }}
            </v-icon>
            <span>{{ formatTime(solicitation.departure_date_time) || '-' }}</span>
          </div>
        </div>
      </div>
      <div class="action-section">
        <v-tooltip
          top
          color="#000000A1"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="#E7E3FC"
              v-bind="attrs"
              @click="$emit('solic-clicked', solicitation)"
              v-on="on"
            >
              <v-icon>{{ icons.mdiEyeOutline }}</v-icon>
            </v-btn>
          </template>
          <span>Abrir detalhes da solicitação</span>
        </v-tooltip>
      </div>
    </section>
  </article>
</template>

<script>
import {
  mdiAccountOutline,
  mdiCalendar, mdiClockTimeEightOutline,
  mdiCommentTextOutline,
  mdiDoorClosed,
  mdiEyeOutline,
  mdiInformationOutline,
  mdiLinkVariant,
  mdiLocationExit,
  mdiOfficeBuildingMarkerOutline,
  mdiSignDirection,
} from '@mdi/js'
import { getBadgeColor, getBorderColor, getCompanyColor } from '../helpers/badgeHelpers'
import {
  formatAddress, formatDate, formatTime, getDriverFirstAndLastName,
  getInitials,
} from '../helpers/formatHelpers'

export default {
  name: 'TransportSolicCard',
  props: {
    solicitation: {
      type: Object,
      required: true,
    },
    solicType: {
      type: String,
      required: true,
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      icons: {
        mdiAccountOutline, mdiLocationExit, mdiCommentTextOutline, mdiEyeOutline, mdiSignDirection, mdiCalendar, mdiClockTimeEightOutline, mdiInformationOutline, mdiOfficeBuildingMarkerOutline, mdiDoorClosed, mdiLinkVariant,
      },
    }
  },
  methods: {
    getInitials,
    getDriverFirstAndLastName,
    getCompanyColor,
    getBadgeColor,
    getBorderColor,
    formatDate,
    formatTime,
    formatAddress,
  },
}
</script>

<style scoped>
    .content-label {
    color: #7B7792;
    font-weight: 500;
    font-size: 12px;
  }

  .card-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
  }

  .route-section {
    flex: 0 0 340px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .info-grid {
    flex: 0 0 300px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 16px;
  }

  .action-section {
    flex: 0 0 60px;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
  }

  .info-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .info-content {
    color: #E7E3FC;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media (max-width: 1400px) {
    .action-section {
      flex: 0 0 50px;
    }

    .info-grid {
      flex: 0 0 280px;
    }

    .route-section {
      flex: 0 0 320px;
    }
  }

  @media (max-width: 1340px) {
    .action-section {
      flex: 0 0 30px;
    }

    .header-section {
      flex-direction: column;
      gap: 10px;
    }

    .info-grid {
      flex: 0 0 250px;
    }

    .route-section {
      flex: 0 0 300px;
    }
  }

  @media (max-width: 1220px) {
    .card-content {
      flex-direction: column;
      gap: 16px;
    }

    .route-section,
    .info-grid,
    .action-section {
      flex: none;
      width: 100%;
    }

    .info-grid {
      gap: 12px;
    }

    .action-section {
      justify-content: flex-end;
      padding-top: 8px;
      height: auto;
    }
  }

  .badge {
    padding: 3px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    font-weight: 600;
    text-align: center;
    font-size: 12px;
  }
  .badge-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .separator {
    height: 1px;
    width: 100%;
    background-color: #534D74;
  }
  .solic-card {
    color: #E7E3FC;
    display: flex;
    gap: 16px;
    flex-direction: column;
    border-radius: 10px;
    padding: 15px 48px 26px 38px;
    border-left: 11px solid;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    /* background-color: #3B355A; */
  }
</style>
